import React from 'react'
import BulkInviteWizard from 'src/app/BulkInvite/BulkInviteWizard'
import { BulkInviteProvider } from 'src/app/BulkInvite/context/BulkInviteContext'
import FullscreenModalShell from 'src/app/BulkInvite/shells/FullscreenModalShell'
import { useBulkInviteStrings } from 'src/app/BulkInvite/useBulkInviteStrings'

interface BulkInviteModalProps {
  /** Closes the modal — callers typically strip the `bulkInvite` query param. */
  onClose: () => void
}

/**
 * The Bulk Invite (CSV) flow as a fullscreen modal layered over the live People
 * page. Mounted by PeopleMembers when `?bulkInvite=1` is present and the
 * `bulk_invite_csv` remote-config flag is enabled.
 */
const BulkInviteModal: React.FC<BulkInviteModalProps> = ({ onClose }) => {
  const strings = useBulkInviteStrings()

  return (
    <BulkInviteProvider>
      <FullscreenModalShell onClose={onClose} ariaLabel={strings.shellTitle}>
        <BulkInviteWizard onClose={onClose} />
      </FullscreenModalShell>
    </BulkInviteProvider>
  )
}

export default BulkInviteModal
